import { useMemo } from "react"
import type { CombinedError, UseQueryExecute } from "urql"
import { useQuery } from "urql"

import type { InstructionProduct, Query } from "@/graphql/codegen/graphql"
import { InstructionProductsDocument } from "@/graphql/codegen/graphql"

interface UseGetProductsReturn {
  products: InstructionProduct[]
  fetchingProducts: boolean
  error?: CombinedError
  reexecuteQuery: UseQueryExecute
}

const useProductsByInstructionList = ({
  instructionId,
  pause,
}: {
  instructionId?: string
  pause: boolean
}): UseGetProductsReturn => {
  const [{ error, data, fetching }, reexecuteQuery] = useQuery<Pick<Query, "instruction">>({
    query: InstructionProductsDocument,
    variables: {
      input: {
        filter: {
          instructionId,
        },
      },
    },
    pause,
  })

  const products = useMemo(() => {
    if (data?.instruction?.listInstructionProduct?.__typename === "InstructionProductListSuccess") {
      return data?.instruction?.listInstructionProduct?.instructionProduct
    }
    return []
  }, [data?.instruction?.listInstructionProduct])

  return {
    products,
    fetchingProducts: fetching,
    error,
    reexecuteQuery,
  }
}

export default useProductsByInstructionList
